function BaseOfCaseShowColumn(reconnaissance, physicalExamination, mainDiagnosis, recommendations, drugList, documentList,
                              icfClassifications, icd9Procedure) {

    this.reconnaissance = reconnaissance;
    this.physicalExamination = physicalExamination;
    this.mainDiagnosis = mainDiagnosis;
    this.recommendations = recommendations;
    this.drugList = drugList;
    this.documentList = documentList;
    this.icfClassifications = icfClassifications;
    this.icd9Procedure = icd9Procedure;

    var _typeContext = {
    };

    this._getType = function(property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    }
}
